import { Datum } from '../../types';

export const getSubTitle = (data: Datum[]) =>
  `${data
    .slice(0, 2)
    .map((n) => n.label)
    .join(', ')}${data.length > 1 ? '...' : ''}`;
